const TOKEN_KEY = 'token';

/**
 * Read the Sanctum bearer token from session (non-remember) or local (remember) storage.
 */
export function getAuthToken() {
	return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

/**
 * Persist the token. Remember Me → localStorage (survives browser restart).
 * Otherwise → sessionStorage (clears when the tab/window closes).
 */
export function setAuthToken(token, remember = false) {
	clearAuthToken();

	if (!token) {
		return;
	}

	if (remember) {
		localStorage.setItem(TOKEN_KEY, token);
	} else {
		sessionStorage.setItem(TOKEN_KEY, token);
	}
}

export function clearAuthToken() {
	localStorage.removeItem(TOKEN_KEY);
	sessionStorage.removeItem(TOKEN_KEY);
}
